export default __webpack_public_path__ + "media/components/AdEdit/images/instagram-brand-a4541e00b42f35b80b81ba103e5032da.png";